import { useCallback } from 'react';

/**
 * Returns a memoized onError handler that swaps the failing image's source
 * with a placeholder graphic. This prevents broken images from appearing
 * in the UI.
 *
 * @param placeholder - Path to the fallback image. Defaults to `/placeholder.svg`.
 */
export function useImageFallback(
  placeholder = '/placeholder.svg',
) {
  return useCallback(
    (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
      const target = e.currentTarget;
      // Avoid infinite loop if the placeholder fails to load.
      target.onerror = null;
      target.src = placeholder;
    },
    [placeholder],
  );
}
